import script from "./EducationsView.vue?vue&type=script&setup=true&lang=js"
export * from "./EducationsView.vue?vue&type=script&setup=true&lang=js"

import "./EducationsView.vue?vue&type=style&index=0&id=7359bbdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7359bbdc"]])

export default __exports__